import { HomeBanner } from '@/types/home';
import { getMultiLangAttr, getLangSuffix } from '@/business/home-newest';
import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';
import { getHomeBiExt } from '@/business/home-bi-helper';

/**
 * 格式化聚合首页banner数据
 */
export function handleHomeBanner(data: DpItem[] = []) {
  const result: HomeBanner[] = data.map((item, index) => {
    const { imgObj, jumpType, appid, username, path, bannerAltObj } = item.contentBaseData as any;
    return {
      jumpUrl: item.contentBaseData[`jumpUrl${getLangSuffix()}`] || item.contentBaseData['jumpUrl'],
      jumpType,
      img: getMultiLangAttr(imgObj),
      id: item.dpId,
      reportInfo: getHomeBiExt(item, {
        fbanner_no: `${index + 1}`,
      }),
      appid,
      username,
      path,
      bannerAlt: getMultiLangAttr(bannerAltObj) || 'banner',
    };
  });
  return result;
}

